import { AccountSecurityFormType } from './AccountSecurity';
import { AccountSecurityActionType } from './accountSecurityActionType';

export default class AccountSecurityActions {
    public static closeAccountSecurityOverlay() {
        return {
            payload: {},
            type: AccountSecurityActionType.CLOSE_ACCOUNT_SECURITY_OVERLAY,
        };
    }

    public static openAccountSecurityOverlay() {
        return {
            payload: {},
            type: AccountSecurityActionType.OPEN_ACCOUNT_SECURITY_OVERLAY,
        };
    }

    public static changeAccountSecurityOverlay(content: AccountSecurityFormType | undefined) {
        return {
            payload: content,
            type: AccountSecurityActionType.CHANGE_ACCOUNT_SECURITY_OVERLAY,
        };
    }

    public static clearPassword() {
        return { payload: {}, type: AccountSecurityActionType.CLEAR_PASSWORD };
    }
}
